import { TextLink, Typography } from 'components';
import useGetKitIdParam from 'hooks/useGetKitIdParam';
import React from 'react';
import useFeature from 'services/features/useFeature';
import styles from './YourCategoryScores.module.css';
import YourCategoryScoresCards from './YourCategoryScoresCards';

type YourCategoryScoresProps = {
  featureFlagFallback?: React.ReactNode;
};

export default function YourCategoryScores({
  featureFlagFallback,
}: YourCategoryScoresProps) {
  const { isFeatureEnabled: isAllMetricsRedesignEnabled } = useFeature(
    'all_metrics_page_redesign',
  );
  const currentKitId = useGetKitIdParam();

  if (!isAllMetricsRedesignEnabled) return featureFlagFallback;

  const metricsUrl = `/results/${currentKitId}/metrics/all-metrics`;

  return (
    <div className={styles.container}>
      <div className={styles.titleAndLink}>
        <Typography variant='heading-m'>Your metrics</Typography>
        <TextLink
          label='View all metrics'
          to={metricsUrl}
          size='heading-s'
          iconNameRight='chevronForward'
          className='hide-on-mobile'
        />
        <TextLink
          label='All metrics'
          to={metricsUrl}
          size='heading-s'
          className='hide-on-desktop'
        />
      </div>
      <YourCategoryScoresCards />
    </div>
  );
}
